import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-profile-unavailabilities" }
const _hoisted_2 = {
  key: 1,
  class: "b-profile-unavailabilities--no-results"
}
const _hoisted_3 = { class: "h-pr-50" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "b-profile-unavailabilities__inner" }
const _hoisted_6 = { class: "b-profile-unavailabilities__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UnavailabilitiesCards = _resolveComponent("UnavailabilitiesCards")!
  const _component_FwSpinLoader = _resolveComponent("FwSpinLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_UnavailabilitiesCards, {
        forceUpdating: _ctx.forceUpdating,
        events: _ctx.events,
        title: _ctx.title,
        startDate: _ctx.startDate,
        onUpdate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fetchCalendarDataRec(1, true))),
        onAsRange: _ctx.asRangeHandler
      }, null, 8, ["forceUpdating", "events", "title", "startDate", "onAsRange"])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
          key: 0,
          colors: ["#27dbbd", "#27DBBD", "#27DBBD"],
          class: "h-flex-center loader",
          isActive: _ctx.loading,
          className: "h-p-20"
        }, null, 8, ["isActive"]))
      : (!_ctx.events.length && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: _ctx.requireImage("calendar-big.svg")
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('UNAVAILABILITIES.TITLE')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}